// extracted by mini-css-extract-plugin
export default {"List":"styles_List__sP3t4","List__item":"styles_List__item__Ro5tz"};